function copyUsingExecCommand(text, callback) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  document.body.appendChild(textarea);
  textarea.select();
  
  try {
    document.execCommand('copy');
    callback()
  } catch (err) {
    console.error(err);
  }
  
  document.body.removeChild(textarea);
}

function copyToClipboardBest(text, callback) {
  // 先尝试使用现代API，失败则回退到旧方法
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text)
      .then(() => {
        callback()
      })
      .catch(err => {
        console.error(err);
        copyUsingExecCommand(text, callback);
      });
  } else {
    copyUsingExecCommand(text, callback);
  }
}

const setupSoundDesignSwiper = () => {
  let soundDesignSwiper = null;

  // Swiper配置
  const swiperConfig = {
    slidesPerView: 4,
    spaceBetween: 26,
    navigation: {
      nextEl: ".bf-sound-design .swiper-button-next",
      prevEl: ".bf-sound-design .swiper-button-prev",
    },
  };

  // 初始化Swiper
  function initSwiper() {
    if (!soundDesignSwiper) {
      const swiperElement = document.querySelector(".bf-sound-design .swiper");
      if (swiperElement) {
        soundDesignSwiper = new Swiper(
          ".bf-sound-design .swiper",
          swiperConfig
        );
      }
    }
  }

  // 销毁Swiper
  function destroySwiper() {
    if (soundDesignSwiper) {
      soundDesignSwiper.destroy(true, true);
      soundDesignSwiper = null;
    }
  }

  // 处理窗口宽度变化
  function handleResize() {
    const width = window.innerWidth;
    if (width < 700) {
      destroySwiper();
    } else {
      initSwiper();
    }
  }

  // 防抖函数
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // 创建防抖后的resize处理函数
  const debouncedHandleResize = debounce(handleResize, 250);

  // 监听窗口大小变化
  window.addEventListener("resize", debouncedHandleResize);

  // 初始检查
  handleResize();
};

const setupCollectionTab = () => {
  const collectionTabList = document.querySelectorAll('.bf-collections .tabs .item');
  const collectionList = document.querySelectorAll('.bf-collections .product-list')
  console.log('collectionList', collectionList)
  collectionTabList.forEach(item => {
    item.addEventListener('click', () => {
      const currentCollection = item.getAttribute('data-collection');
      collectionTabList.forEach(tab => {
        tab.classList.remove('active');
      });
      item.classList.add('active');
      collectionList.forEach(collection => {
        if (collection.getAttribute('data-collection') === currentCollection) {
          collection.classList.add('active');
        } else {
          collection.classList.remove('active');
        }
      })
    })
  })
}

const setupFlashSaleModule = async () => {
  const btnBoxList = document.querySelectorAll('.bf-flash-sale .btn');
  btnBoxList.forEach(item => {
    item.addEventListener('click', (event) => {
      const target = event.target

      if (target.tagName === 'BUTTON') {
        console.log('click')
        copyToClipboardBest(target.getAttribute('data-discount-code'), () => {
          const popoverEle = document.createElement('div');
          popoverEle.classList.add("extend-popover", "extend-popover__discount");
          popoverEle.innerHTML = `
            <div class="ep-overlay no-hide-on-click"></div>
            <div class="ep-main no-hide-on-click">
              <div class="ep-inner v-stack gap-2">
                <div class="h-stack items-center justify-between">
                  <div class="h-stack grow gap-2 sm:gap-2.5">
                    <p class="h5">クーポンコードをコピーしました！</p>
                  </div>
                  <button type="button" class="ep-close ">
                    <span class="sr-only">閉める</span>
                    <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
                    <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
                  </svg>
                  </button>
                </div>
                <div class="ep-content">
                  <div class="prose text-base">${item.getAttribute('data-product-name')}のご購入時にご利用いただくと、特別価格でお買い求めいただけます。</div>
                </div>
                <div class="ep-footer">
                  <a target="_blank" href="${item.getAttribute('data-product-link')}" class="btn">今すぐ購入</a>
                </div>
              </div>
            </div>
          `
          document.body.appendChild(popoverEle);
          document.body.style.overflow = 'hidden';
          popoverEle.querySelector('.ep-overlay').addEventListener('click', (e) => {
            e.stopPropagation();
            console.log('overlay')
          })
          popoverEle.querySelector('.ep-overlay').addEventListener('touchend', (e) => {
            e.stopPropagation();
            console.log('overlay')
          })
          popoverEle.querySelector('.ep-close').addEventListener('click', (e) => {
            e.stopPropagation();
            popoverEle.remove()
            document.body.style.overflow = 'auto';
            console.log('close')
          })
          popoverEle.querySelector('.ep-close').addEventListener('touchend', (e) => {
            e.stopPropagation();
            popoverEle.remove()
            document.body.style.overflow = 'auto';
            console.log('close')
          })
        });
      }
    })
  })
}


setupSoundDesignSwiper()
setupCollectionTab()
setupFlashSaleModule()

function formatNumber(num) {
  return num < 10 ? `0${num}` : num;
}
function setupSingleCountdown(selector, getContentHtml, options = { showEndText: true }) {
  let timeDifference;
  let day, hours, minutes, seconds;
  const { showEndText, apiQuery } = options;
  const baseURL = 'https://foreign-analysis.edifier.com:8519';
  let currentStatus;
  let flashSaleBtnList;
  let isFetchingDiscount = false;
  let discountList = [];
  let countdownClientStart;

  function updateCountdownNodes(selector, html) {
    document.querySelectorAll(selector).forEach((item) => {
      item.innerHTML = html;
    });
  }

  fetch(`${baseURL}/api/lottery/v1/checkSessionStatus?session=${apiQuery.index}`, { method: 'get' })
    .then(function (response) {
      return response.json();
    })
    .then(function (res) {
      const serverCountdown = res.data.countdown;
      let countdownText;
      switch (res.data.status) {
        case 0:
          countdownText = '開始まで';
          break;
        case 1:
          countdownText = '終了まで';
          break;
        case 2:
          countdownText = showEndText ? 'セール終了しました' : '';
          break;
      }
      countdownClientStart = Date.now();
      let countdownTimer = window.setInterval(() => {
        const elapsed = Date.now() - countdownClientStart;
        timeDifference = serverCountdown - elapsed;
        const safeTimeDifference = Math.max(timeDifference, 0);

        days = Math.floor(safeTimeDifference / (1000 * 60 * 60 * 24));
        hours = Math.floor((safeTimeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        minutes = Math.floor((safeTimeDifference % (1000 * 60 * 60)) / (1000 * 60));
        seconds = Math.floor((safeTimeDifference % (1000 * 60)) / 1000);

        if (['.countdown-session-1', '.countdown-session-2', '.countdown-session-3'].includes(selector)) {
          if (!flashSaleBtnList) {
            flashSaleBtnList = document.querySelectorAll(`.bf-flash-sale .product:nth-child(${apiQuery.index + 1}) .btn`)
          }
          const btnList = flashSaleBtnList;
          if (!btnList.length) return;
          if (res.data.status == 0 && currentStatus != res.data.status) {
            btnList.forEach((item) => {
              item.innerHTML = `<a target="_blank" href="${item.getAttribute('data-product-link')}">販売開始を待つ</a>`;
            });
          }
          if (res.data.status == 1) {
            countdownText = '';
            if (currentStatus != res.data.status && !isFetchingDiscount) {
              isFetchingDiscount = true;
              fetch(`${baseURL}/api/lottery/v1/checkDiscountCode`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify([apiQuery.discount])
              }).then(response => response.json())
              .then(res => {
                if (res.code === 0) {
                  discountList = res.data;
                  btnList.forEach((item, index) => {
                    if (discountList[index].remainCount > 0) {
                      item.innerHTML = `<button class="dialog-btn" data-discount-code="${discountList[index].discountCode}">今すぐ購入する</button>`;
                    } else {
                      item.innerHTML = `<a target="_blank" href="${item.getAttribute('data-product-link')}">特価終了｜ブラックフライデー価格をチェック</a>`;
                    }
                  });
                }
              })
              .catch((error) => {
                console.log('error', error);
              })
              .finally(() => {
                isFetchingDiscount = false;
              });
            }
            updateCountdownNodes(selector, countdownText);
          }

          if (res.data.status == 2 && currentStatus != res.data.status) {
            console.log('status', currentStatus, res.data.status);
            btnList.forEach((item) => {
              item.innerHTML = `<a target="_blank" href="${item.getAttribute('data-product-link')}">今すぐ購入する</a>`;
            });
          }

          // // seem to no resonse
          // if (res.data.status == 1) {
          //   currentStatus = res.data.status;
          //   return
          // }
        }

        // if (res.data.status == 2) {
        //   return;
        // }

        if (!(res.data.status == 1 && ['.countdown-session-1', '.countdown-session-2', '.countdown-session-3'].includes(selector))) {
          updateCountdownNodes(
            selector,
            getContentHtml(countdownText, days, hours, minutes, seconds)
          );
        }

        currentStatus = res.data.status;

        if (res.data.status === 2) {
          updateCountdownNodes(selector, countdownText);
          window.clearInterval(countdownTimer);
          countdownTimer = null;
          return;
        }
  
        if (timeDifference <= 0) {
          window.clearInterval(countdownTimer);
          countdownTimer = null;
          setupSingleCountdown(selector, countdownText, options);
        }
      }, 1000);
    });
}

setupSingleCountdown('.countdown-session-1', (countdownText, days, hours, minutes, seconds) => {
  return `
    <span class="ssabt-text">${countdownText}</span>
    <div class="ssabt-countdown">
        <span class="ssabt-item ssabt-day">${formatNumber(days)}</span>
        <span class="ssabt-label">日</span>
        <span class="ssabt-item ssabt-hour">${formatNumber(hours)}</span>
        <span class="ssabt-label">時</span>
        <span class="ssabt-item ssabt-minute">${formatNumber(minutes)}</span>
        <span class="ssabt-label">分</span>
        <span class="ssabt-item ssabt-second">${formatNumber(seconds)}</span>
        <span class="ssabt-label">秒</span>
    </div>
  `;
}, { showEndText: false, apiQuery: {index: 1, discount: 'BFFSNB'} });

setupSingleCountdown('.countdown-session-2', (countdownText, days, hours, minutes, seconds) => {
  return `
    <span class="ssabt-text">${countdownText}</span>
    <div class="ssabt-countdown">
        <span class="ssabt-item ssabt-day">${formatNumber(days)}</span>
        <span class="ssabt-label">日</span>
        <span class="ssabt-item ssabt-hour">${formatNumber(hours)}</span>
        <span class="ssabt-label">時</span>
        <span class="ssabt-item ssabt-minute">${formatNumber(minutes)}</span>
        <span class="ssabt-label">分</span>
        <span class="ssabt-item ssabt-second">${formatNumber(seconds)}</span>
        <span class="ssabt-label">秒</span>
    </div>
  `;
}, { showEndText: false, apiQuery: {index: 2, discount: 'BFFSSP'} });

setupSingleCountdown('.countdown-session-3', (countdownText, days, hours, minutes, seconds) => {
  return `
    <span class="ssabt-text">${countdownText}</span>
    <div class="ssabt-countdown">
        <span class="ssabt-item ssabt-day">${formatNumber(days)}</span>
        <span class="ssabt-label">日</span>
        <span class="ssabt-item ssabt-hour">${formatNumber(hours)}</span>
        <span class="ssabt-label">時</span>
        <span class="ssabt-item ssabt-minute">${formatNumber(minutes)}</span>
        <span class="ssabt-label">分</span>
        <span class="ssabt-item ssabt-second">${formatNumber(seconds)}</span>
        <span class="ssabt-label">秒</span>
    </div>
  `;
}, { showEndText: false, apiQuery: {index: 3, discount: 'BFFSEVO'} });


